var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2541_158022)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2541_158022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64348 3.61632C1.11786 6.57467 0.657993 11.831 3.61634 15.3566C6.57469 18.8822 11.831 19.3421 15.3566 16.3837C18.8822 13.4254 19.3421 8.16908 16.3837 4.64346C13.4254 1.11783 8.1691 0.657969 4.64348 3.61632Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 9.95884C15.8177 10.451 16.6192 10.2005 16.6782 9.56037L17.0979 5.01351C17.1508 4.43492 16.7223 3.92422 16.1433 3.87593L11.5927 3.49969C10.952 3.44659 10.5661 4.19244 10.9791 4.68462L15.4047 9.95884Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48784 14.2837L16.05 7.09918L13.9074 4.5457L5.34521 11.7302L7.48784 14.2837Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34237 11.7233C4.63724 12.3149 4.54527 13.3662 5.13694 14.0713C5.72861 14.7765 6.77987 14.8684 7.48499 14.2768C8.19012 13.6851 8.28209 12.6338 7.69042 11.9287C7.09875 11.2236 6.04749 11.1316 5.34237 11.7233Z",
    fill: "#6C6C6C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2541_158022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2541_158022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(24.0884 11.2326) rotate(140)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.0387a700abfb49f7f0ce19065bbc02d6.svg";
export { ForwardRef as ReactComponent };